import { ReactElement } from 'react';
import { HStack, Text } from '@chakra-ui/react';
import { SuccessIcon } from 'assets/icons/v2';

/** "Done" indicator — shown next to reading time/years once the user has read the article. */
export const ReadBadge = (): ReactElement => (
  <HStack gap="4px" alignItems="center">
    <SuccessIcon glyphSize="m" color="icon.accent" />
    <Text textStyle="body.s.regular" color="text.accent" whiteSpace="nowrap">
      Fertig
    </Text>
  </HStack>
);
